import * as React from 'react';
import { SvgIcon } from '../../icons/SvgIcon';

interface IProps {
	className?: string;
}

export const AutoEmailConfigIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`auto-email-config-icon ${className || ''}`} height={689} width={689}>
			<circle cx='344.5' cy='344.5' r='344.5' fill='#FFE9F8' />
			<path
				d='M458.718 305.072h-.124l-71.491 30.527-97.813 41.767a3.151 3.151 0 01-2.416.012l-100.915-41.866-73.246-30.39-.112-.05h-.125a4.365 4.365 0 00-4.359 4.359v189.312a4.365 4.365 0 004.359 4.36h346.242a4.364 4.364 0 004.359-4.36V309.431a4.363 4.363 0 00-4.359-4.359z'
				fill='#fff'
			/>
			<path
				d='M459.029 306.318a.623.623 0 01-.356-.112L286.45 186.265a3.122 3.122 0 00-3.567.006L111.9 306.205a.623.623 0 01-.716-1.02l170.983-119.934a4.373 4.373 0 014.995-.008l172.223 119.941a.623.623 0 01-.356 1.134z'
				fill='#3F3D56'
			/>
			<path d='M284.834 189.645l164.403 129.529L286 421 121.67 310.57l163.164-120.925z' fill='#E6E6E6' />
			<path
				d='M287.129 377.923a4.702 4.702 0 01-1.787-.35l-100.628-41.754V205.123a4.365 4.365 0 014.359-4.359h193.049a4.365 4.365 0 014.359 4.359V335.91l-.189.081-97.322 41.562a4.77 4.77 0 01-1.841.37z'
				fill='#fff'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M285.224 377.861a5.05 5.05 0 003.868-.022l97.7-41.723V205.123a4.676 4.676 0 00-4.67-4.671H189.073a4.677 4.677 0 00-4.671 4.671v130.904l100.822 41.834zm.475-1.151l-100.051-41.515V205.123a3.428 3.428 0 013.425-3.425h193.049a3.43 3.43 0 013.425 3.425v130.171l-96.941 41.398a3.812 3.812 0 01-2.907.018z'
				fill='#3F3D56'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M457.659 305.072h.125a4.365 4.365 0 014.359 4.359v189.312a4.365 4.365 0 01-4.359 4.36H111.542a4.365 4.365 0 01-4.359-4.36V309.431a4.365 4.365 0 014.359-4.359h.125l.112.05 73.246 30.39 100.914 41.866a3.154 3.154 0 002.417-.012l97.813-41.767 71.49-30.527zm.125 196.785a3.116 3.116 0 003.114-3.114V309.431a3.124 3.124 0 00-2.989-3.113l-71.74 30.632-97.321 41.562a4.434 4.434 0 01-3.388.018l-100.435-41.673-73.601-30.539a3.12 3.12 0 00-2.996 3.113v189.312a3.116 3.116 0 003.114 3.114h346.242z'
				fill='#3F3D56'
			/>
			<path
				d='M271.463 249.618h-68.501a4.98 4.98 0 010-9.963h68.501a4.982 4.982 0 010 9.963zm-35.496-21.173h-33.005a4.982 4.982 0 110-9.963h33.005a4.982 4.982 0 110 9.963z'
				fill='#C75DA6'
			/>
			<path
				d='M336.831 299.437h-104.62a4.982 4.982 0 010-9.963h104.62a4.982 4.982 0 010 9.963zm0 23.042h-104.62a4.983 4.983 0 010-9.964h104.62a4.982 4.982 0 110 9.964z'
				fill='#CCC'
			/>
			<circle cx='171.853' cy='241.878' r='47.371' fill='#C75DA6' />
			<circle
				cx='172'
				cy='242'
				stroke='#A7ABAD'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				r='8.727'
			/>
			<path
				clipRule='evenodd'
				d='M193.527 250.727a4.802 4.802 0 00.96 5.295l.175.174a5.823 5.823 0 01-4.117 9.939 5.815 5.815 0 01-4.116-1.706l-.174-.174a4.798 4.798 0 00-5.295-.96 4.8 4.8 0 00-2.909 4.392v.495a5.818 5.818 0 01-11.636 0v-.262a4.803 4.803 0 00-3.142-4.393 4.802 4.802 0 00-5.295.96l-.174.175a5.823 5.823 0 01-9.939-4.117c0-1.544.613-3.025 1.706-4.116l.174-.174a4.798 4.798 0 00.96-5.295 4.8 4.8 0 00-4.392-2.909h-.495a5.818 5.818 0 010-11.636h.262a4.803 4.803 0 004.393-3.142 4.802 4.802 0 00-.96-5.295l-.175-.174a5.823 5.823 0 014.117-9.939c1.544 0 3.025.613 4.116 1.706l.174.174a4.798 4.798 0 005.295.96h.233a4.8 4.8 0 002.909-4.392v-.495a5.818 5.818 0 0111.636 0v.262a4.802 4.802 0 002.909 4.393 4.802 4.802 0 005.295-.96l.174-.175a5.823 5.823 0 019.939 4.117 5.815 5.815 0 01-1.706 4.116l-.174.174a4.798 4.798 0 00-.96 5.295v.233a4.8 4.8 0 004.392 2.909h.495a5.818 5.818 0 010 11.636h-.262a4.802 4.802 0 00-4.393 2.909z'
				stroke='#A7ABAD'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<circle cx='344.614' cy='244.342' r='64.5' fill='#fff' />
			<path
				d='M331.454 260.672h-38.253c-10.099-.16-18.202-8.39-18.206-18.489-.004-10.1 8.093-18.337 18.191-18.505h38.285c.188-.003.392-.003.594 0 10.165.14 18.312 8.456 18.245 18.621-.068 10.165-8.324 18.371-18.489 18.377-.123 0-.245-.001-.367-.004zm67.856 121.059a6.527 6.527 0 01-.63-1.259l-5.163-13.827a6.507 6.507 0 013.815-8.363l115.242-43.032a6.506 6.506 0 018.363 3.815l5.163 13.828a6.498 6.498 0 01-3.816 8.363l-115.241 43.031a6.505 6.505 0 01-7.733-2.556z'
				fill='#C75DA6'
			/>
			<path
				d='M512.207 311.677l-46.863 18.687a6 6 0 00-4.093 7.2l5.439 21.775a6 6 0 008.376 3.975l46.992-22.119a6.01 6.01 0 003.525-7.717l-5.649-18.275a6.011 6.011 0 00-7.727-3.526z'
				fill='#2F2E41'
			/>
			<path
				d='M597.969 447.339a6.507 6.507 0 01-6.892-4.34L550.963 326.71a6.5 6.5 0 014.025-8.265l13.953-4.813a6.504 6.504 0 018.264 4.025l40.114 116.29a6.507 6.507 0 01-4.025 8.264l-13.953 4.813a6.566 6.566 0 01-1.372.315z'
				fill='#C75DA6'
			/>
			<path
				d='M580.195 315.667l15.396 48.045a6.002 6.002 0 01-2.951 7.739l-20.261 9.657a6 6 0 01-8.395-3.934l-12.831-50.328a6.011 6.011 0 013.712-7.629l17.694-7.269a6.012 6.012 0 017.636 3.719zM533.58 572.003h-14.76a6.508 6.508 0 01-6.5-6.5V442.488a6.509 6.509 0 016.5-6.5h14.76a6.508 6.508 0 016.5 6.5v123.015a6.508 6.508 0 01-6.5 6.5zm29.192 0h-14.76a6.508 6.508 0 01-6.5-6.5V442.488a6.508 6.508 0 016.5-6.5h14.76a6.508 6.508 0 016.5 6.5v123.015a6.508 6.508 0 01-6.5 6.5z'
				fill='#2F2E41'
			/>
			<path
				d='M574.936 456.951h-67.063a7.009 7.009 0 01-7-7V341.006c0-22.385 18.147-40.531 40.531-40.531 22.385 0 40.532 18.146 40.532 40.531v108.945a7.009 7.009 0 01-7 7z'
				fill='#CCC'
			/>
			<path
				d='M585.03 483.6h-34V291.445l.632.173c19.681 5.402 33.334 23.278 33.368 43.687V483.6zm-56.015 0h-34V335.305c.034-20.409 13.688-38.285 33.369-43.687l.631-.173V483.6z'
				fill='#2F2E41'
			/>
			<circle cx='540.878' cy='245.44' r='37.5' fill='#C75DA6' />
			<path
				d='M421.571 386.833a6 6 0 01-7.968-2.918l-34.511-74.384a6 6 0 0110.886-5.05l34.511 74.384a6 6 0 01-2.918 7.968z'
				fill='#3F3D56'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M280.17 273.399c17.896 38.567 63.675 55.326 102.249 37.433 38.536-17.929 55.285-63.662 37.44-102.231-17.897-38.567-63.675-55.326-102.25-37.433-38.574 17.894-55.336 63.664-37.439 102.231zm17.183-8.711c-13.362-28.806-.847-62.991 27.953-76.355 28.802-13.326 62.953-.819 76.341 27.958 13.362 28.805.847 62.991-27.953 76.355-28.8 13.365-62.979.847-76.341-27.958z'
				fill='#3F3D56'
			/>
		</SvgIcon>
	);
};
